import * as Yup from 'yup';
import { ValidationErrors, ValidationResult } from '../types';

const validateForm = async <T extends Record<string, any>>(
  formData: T,
  schema: Yup.ObjectSchema<any>,
  fieldsToCheck?: (keyof T)[]
): Promise<ValidationResult<T>> => {
  try {
    await schema.validate(formData, { abortEarly: false });
    return { valid: true, errors: {} };
    
  } catch (validationError: any) {
    const fieldErrors: ValidationErrors<T> = {};

    const errors = Array.isArray(validationError?.inner)
      ? validationError.inner
      : [];

    for (const error of errors) {
      const field = error?.path as keyof T | undefined;
      if (!field) continue;

      const isRelevant = !fieldsToCheck || fieldsToCheck.includes(field);
      if (!isRelevant) continue;

      if (!(field in fieldErrors)) {
        fieldErrors[field] = error.message;
      }
    }

    return { valid: false, errors: fieldErrors };
  }
};

export { validateForm };
